import { render, staticRenderFns } from "./recomendDoctortizhi.vue?vue&type=template&id=48e78c63&"
import script from "./recomendDoctortizhi.vue?vue&type=script&lang=js&"
export * from "./recomendDoctortizhi.vue?vue&type=script&lang=js&"
import style0 from "./recomendDoctortizhi.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./recomendDoctortizhi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports